<template>
    <el-table :data="data" style="width: 100%;" :height="tableHeight" :highlight-current-row="true">
        <el-table-column >
            <template slot="header" slot-scope="scope">
                <el-input placeholder="请输入人员名称" v-model="searchText" size="small" style="width: 94%;margin-left:3%;" @input="handleSearch"/>
            </template>
            <template slot-scope="scope">
                <div @click="handleClick(scope.row)" v-if="type === 'team'">{{scope.row.personName ||scope.row.personShopName}}</div>
                <div  v-else-if="type === 'waitClinic'">
                    <div style="font-size: 12px;color: #595959;">{{scope.row.address}}</div>
                    <div style="font-weight: 600;">{{scope.row.shopName}}</div>
                </div>
                <div  v-else-if="type === 'assigned'">{{scope.row.shopName}}</div>
            </template>
        </el-table-column>
    </el-table>
</template>
<script>
export default {
    name: "salesMethodTable",
    props: {
        tableHeight: {
            type: Number,
            default: 300
        },
        tableData: {
            type: Array,
            default: () => []
        },
        type: {
            type: String,
            default: "team"
        }
    },
    watch: {
        tableData: {
            handler(newVal) {
                this.data = newVal
            },
            deep: true
        }
    },
    data() {
        return {
            searchText: "",
            data: this.tableData
        }
    },
    methods: {
        handleSearch() {
            // 过滤数据
            const filterData = this.tableData.filter(item => {
                return item.personName.includes(this.searchText)
            })
            this.data = filterData;
        },
        handleClick(row) {
            // 点击某行触发的事件
            this.$emit("rowClick", row)
        }
    }
}
</script>
<style scoped lang="scss">
</style>